'use client';

import Image from 'next/image';
import RetryErrorButton from '@/components/retry-error-button';
import { getCdnUrl } from '@/utils/url';
const NoResultsImage = getCdnUrl('/_toad/images/no-results.svg');
function PLPError() {
  return <div data-sentry-component="PLPError" data-sentry-source-file="error.tsx">
            <div className='rounded-md bg-white'>
                <div className='flex flex-col items-center justify-center gap-8 px-8 py-10 text-center'>
                    <Image src={NoResultsImage} width={200} unoptimized height={200} alt='تصویر جست‌وجوی بدون نتیجه' data-sentry-element="Image" data-sentry-source-file="error.tsx" />

                    <div className='flex flex-col gap-4'>
                        <p className='text-sm sm:text-base'>خطایی رخ داده است. لطفا دوباره تلاش کنید</p>

                        <RetryErrorButton data-sentry-element="RetryErrorButton" data-sentry-source-file="error.tsx" />
                    </div>
                </div>
            </div>
        </div>;
}
export default PLPError;